import React from "react";
import styled from "styled-components";
import { Block } from "../../components";
import { spacingMixin } from "../../helpers";
import { TColor } from "../../types";
import ColorPreview from "./ColorPreview";

export const capitalize = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const capitalizeWords = (name: string, delimeter: string = "_"): string => {
    return name.split(delimeter).map(capitalize).join(" ");
};

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: ${spacingMixin(2)};
`;

interface IProps {
    group: string;
    colors: TColor[];
}

const ColorsGroup: React.FC<IProps> = ({ group, colors }) => {
    return (
        <Block header={capitalizeWords(group, "-")}>
            <Grid>
                {colors.map(value => (
                    <ColorPreview key={value} value={value} />
                ))}
            </Grid>
        </Block>
    );
};

export default ColorsGroup;
